module.exports = __webpack_public_path__ + "static/media/mission 1.64719310.webp";